import {Injectable} from '@angular/core';
import {noUndefined} from '@angular/compiler/src/util';

@Injectable({
    providedIn: 'root'
})
export class AhmService {

    public version = 'eng';
    // public language;

    // книга которая выбрана по умолчанию
    public choosenBookVersion: string = 'AHM1';

    // links to components
    mainContentComponentLink;
    leftPanelComponentLink;
    loginFormComponentLink;
    topMenuComponentLink;
    appComponentLink;
    dynamicComponentLink;
    navigationComponentLink;
    homeComponentLink;

    // pages data
    private ahm1engpages: any;
    private ahm1ruspages: any;

    constructor() {
        // this.language = 'eng';
    }

    public setPagesData(data, version) {
        if ('ahm1eng' === version) {
            this.ahm1engpages = data;
        } else if ('ahm1rus' === version) {
            this.ahm1ruspages = data;
        }
    }

    public getPagesData(version) {

        this.resetComponents();

        if ('ahm1eng' === version) {
            return this.ahm1engpages;
        } else if ('ahm1rus' === version) {
            return this.ahm1ruspages;
        }
    }

    // public allComponentsDefinedAndInService(version) {
    //   console.log('allComponentsDefinedAndInService', this.getMainContentComponentLink);
    //   if (
    //     noUndefined(this.mainContentComponentLink) &&
    //     noUndefined(this.loginFormComponentLink) &&
    //     noUndefined(this.leftPanelComponentLink) &&
    //     noUndefined(this.topMenuComponentLink) &&
    //     noUndefined(this.loginFormComponentLink)
    //   ) {
    //     console.log('allComponentsDefinedAndInService:translate');
    //     this.translate(version);
    //   } else {
    //     console.log('allComponentsDefinedAndInService:timeout');
    //
    //     window.setTimeout(AhmService.prototype.allComponentsDefinedAndInService, 1000);
    //   }
    // }


    public translateComponent(componentLink, componentNameSelector) {

        // this.resetComponents();

        switch (componentNameSelector) {
            case 'main-page': {
                if ('eng' === this.version) {
                    // componentLink.homePageLogo = 'assets/images/kompas1339ENG.png';
                    // componentLink.alphabet = 'ALPHABET OF';
                    // componentLink.human = 'THE HUMAN';
                    // componentLink.mind = 'MIND';
                    // componentLink.subtitle = 'psychology flagship';
                    // componentLink.authors = 'Nikita M. Danilov and Ekaterina V. Danilova ©';
                } else if ('rus' === this.version) {
                    // componentLink.homePageLogo = 'assets/images/kompas2339.png';
                    // componentLink.alphabet = 'АЗБУКА';
                    // componentLink.human = 'ЧЕЛОВЕЧЕСКОЙ';
                    // componentLink.mind = 'ПСИХИКИ';
                    // componentLink.subtitle = 'флагман психологии';
                    // componentLink.authors = 'Н.М. Данилов и Е.В.Данилова ©';
                }
                break;
            }
            case 'login-form': {
                // if ('eng' === this.version) {
                //   componentLink.loginform = 'LOGIN FORM';
                //   componentLink.mobile = 'MOBILE PHONE';
                //   componentLink.login = 'LOG IN';
                //   componentLink.close = 'CLOSE';
                //   componentLink.paysub = 'buy subscribe';
                //   componentLink.license = 'license agreement';
                //   componentLink.news = 'NEWS';
                //   componentLink.buy = 'BUY';
                //   componentLink.read = 'READ';
                //   componentLink.map = 'S. MAP';
                //   componentLink.promo = 'PROMO';
                //   componentLink.events = 'EVENTS';
                //   componentLink.discuss = 'DISCUSS';
                //   componentLink.instr = 'INSTR.';
                // }else if ('rus' === this.version) {
                //   componentLink.loginform = 'ФОРМА ВХОДА';
                //   componentLink.mobile = 'МОБИЛЬНЫЙ ТЕЛЕФОН';
                //   componentLink.login = 'ВОЙТИ';
                //   componentLink.close = 'ЗАКРЫТЬ';
                //   componentLink.paysub = 'оплатить подписку';
                //   componentLink.license = 'лицензионное соглашение';
                //   componentLink.news = 'НОВОСТИ';
                //   componentLink.buy = 'КУПИТЬ';
                //   componentLink.read = 'ЧИТАТЬ';
                //   componentLink.map = 'КАРТА С.';
                //   componentLink.promo = 'ПРОМО';
                //   componentLink.events = 'СОБЫТИЯ';
                //   componentLink.discuss = 'ОБСУДИТЬ';
                //   componentLink.instr = 'ИНСТР.';
                // }
                break;
            }
            case 'app-left-panel': {
                if ('eng' === this.version) {
                    componentLink.rideroButtonLink = 'https://ridero.ru/books/alphabet_of_the_human_mind/';
                    componentLink.rideroButtonImage = '../assets/images/button_ro_bw_1339.png';
                    componentLink.amazonButtonLink = 'https://www.amazon.com/dp/B0727Q6YKL';
                    componentLink.amazonButtonImage = '../assets/images/button_am_bw_1339.png';
                    componentLink.boomstarterButtonLink = 'https://boomstarter.ru/projects/niki/flagman_mirovoy_psihologii_-_azbuka_chelovecheskoy_psihiki?utm_source=ahm_site&utm_medium=ahm_book&utm_campaign=book_order&utm_content=1339';
                    componentLink.boomstarterButtonImage = '../assets/images/button_bs_bw_1339.png';
                    componentLink.instagramButtonLink = 'https://www.instagram.com/lifeplaning/';
                    componentLink.instagramButtonImage = '../assets/images/button_in_bw_1339.png';
                    componentLink.vkButtonLink = 'https://vk.com/niki_danilov';
                    componentLink.vkButtonImage = '../assets/images/button_vk_bw_1339.png';
                    componentLink.youtubeButtonLink = 'https://www.youtube.com/channel/UCRbi5fPwF2IZIh7Ho5nzVDA';
                    componentLink.youtubeButtonImage = '../assets/images/button_yt_bw_1339.png';
                    componentLink.fbButtonLink = 'http://facebook.com/NDanilov';
                    componentLink.fbButtonImage = '../assets/images/button_fb_bw_1339.png';
                } else if ('rus' === this.version) {
                    componentLink.rideroButtonLink = 'https://ridero.ru/books/azbuka_chelovecheskoi_psikhiki/';
                    componentLink.rideroButtonImage = '../assets/images/button_ro_bw_1339.png';
                    componentLink.amazonButtonLink = 'https://www.amazon.com/dp/B01KXVU3NO';
                    componentLink.amazonButtonImage = '../assets/images/button_am_bw_1339.png';
                    componentLink.boomstarterButtonLink = 'https://boomstarter.ru/projects/niki/flagman_mirovoy_psihologii_-_azbuka_chelovecheskoy_psihiki?utm_source=ahm_site&utm_medium=ahm_book&utm_campaign=book_order&utm_content=1339';
                    componentLink.boomstarterButtonImage = '../assets/images/button_bs_bw_1339.png';
                    componentLink.instagramButtonLink = 'https://www.instagram.com/lifeplaning/';
                    componentLink.instagramButtonImage = '../assets/images/button_in_bw_1339.png';
                    componentLink.vkButtonLink = 'https://vk.com/ahm333';
                    componentLink.vkButtonImage = '../assets/images/button_vk_bw_1339.png';
                    componentLink.youtubeButtonLink = 'https://www.youtube.com/channel/UCRbi5fPwF2IZIh7Ho5nzVDA';
                    componentLink.youtubeButtonImage = '../assets/images/button_yt_bw_1339.png';
                    componentLink.fbButtonLink = 'http://facebook.com/NDanilov';
                    componentLink.fbButtonImage = '../assets/images/button_fb_bw_1339.png';
                }
                break;
            }
            case 'app-top-menu': {
                if ('eng' === this.version) {
                    componentLink.booksButtonMenuText = 'books';
                    componentLink.aboutButtonMenuText = 'about';
                    componentLink.instrumentsButtonMenuText = 'instruments';
                } else if ('rus' === this.version) {
                    componentLink.booksButtonMenuText = 'книги';
                    componentLink.aboutButtonMenuText = 'о нас';
                    componentLink.instrumentsButtonMenuText = 'инструменты';
                }
                break;
            }

        }

    }


    /**
     * TODO: не загружает язык при старте. пишет компоненты еще не инициализированы если вызов из конструктора или нгОнИнит
     * @param versionS
     */
    public translate(versionS) {
        // set version into service
        // AhmService.prototype.version = versionS;

        // console.log('AhmService.prototype.translate', versionS, this.mainContentComponentLink);

        if (
            noUndefined(this.mainContentComponentLink) &&
            noUndefined(this.loginFormComponentLink) &&
            noUndefined(this.leftPanelComponentLink) &&
            noUndefined(this.topMenuComponentLink) &&
            noUndefined(this.homeComponentLink)
        ) {
            // this.mainContentComponentLink.alphabet = 'alp';

            // let version = this.mainContentComponentLink.version;

            // TODO: why version not changing
            // alert(versionS);

            if ('eng' === versionS) {
                // console.log('translate to eng', versionS);
                // english verion parameters initialising
                // about book
                // this.mainContentComponentLink.homePageLogo = 'assets/images/kompas1339ENG.png';
                // this.mainContentComponentLink.alphabet = 'ALPHABET OF';
                // this.mainContentComponentLink.human = 'THE HUMAN';
                // this.mainContentComponentLink.mind = 'MIND';
                // this.mainContentComponentLink.subtitle = 'psychology flagship';
                // this.mainContentComponentLink.authors = 'Nikita M. Danilov and Ekaterina V. Danilova ©';
                this.translateComponent(this.mainContentComponentLink, 'main-page');
                // // login form
                // this.loginFormComponentLink.loginform = 'LOGIN FORM';
                // this.loginFormComponentLink.mobile = 'MOBILE PHONE';
                // this.loginFormComponentLink.login = 'LOG IN';
                // this.loginFormComponentLink.close = 'CLOSE';
                // this.loginFormComponentLink.paysub = 'buy subscribe';
                this.translateComponent(this.loginFormComponentLink, 'login-form');

                // social
                // this.leftPanelComponentLink.rideroButtonLink = 'https://ridero.ru/books/alphabet_of_the_human_mind/';
                // this.leftPanelComponentLink.rideroButtonImage = '../assets/images/button_ro_bw_1339.png';
                // this.leftPanelComponentLink.amazonButtonLink = 'https://www.amazon.com/dp/B0727Q6YKL';
                // this.leftPanelComponentLink.amazonButtonImage = '../assets/images/button_am_bw_1339.png';
                // this.leftPanelComponentLink.boomstarterButtonLink = 'https://boomstarter.ru/projects/niki/flagman_mirovoy_psihologii_-_azbuka_chelovecheskoy_psihiki?utm_source=ahm_site&utm_medium=ahm_book&utm_campaign=book_order&utm_content=1339';
                // this.leftPanelComponentLink.boomstarterButtonImage = '../assets/images/button_bs_bw_1339.png';
                // this.leftPanelComponentLink.instagramButtonLink = 'https://www.instagram.com/lifeplaning/';
                // this.leftPanelComponentLink.instagramButtonImage = '../assets/images/button_in_bw_1339.png';
                // this.leftPanelComponentLink.vkButtonLink = 'https://vk.com/niki_danilov';
                // this.leftPanelComponentLink.vkButtonImage = '../assets/images/button_vk_bw_1339.png';
                // this.leftPanelComponentLink.youtubeButtonLink = 'https://www.youtube.com/channel/UCRbi5fPwF2IZIh7Ho5nzVDA';
                // this.leftPanelComponentLink.youtubeButtonImage = '../assets/images/button_yt_bw_1339.png';
                // this.leftPanelComponentLink.fbButtonLink = 'http://facebook.com/NDanilov';
                // this.leftPanelComponentLink.fbButtonImage = '../assets/images/button_fb_bw_1339.png';

                this.translateComponent(this.leftPanelComponentLink, 'app-left-panel');

                // top menu
                // this.topMenuComponentLink.booksButtonMenuText = 'books';
                // this.topMenuComponentLink.aboutButtonMenuText = 'about';
                // this.topMenuComponentLink.instrumentsButtonMenuText = 'i-n-s-t-r-u-m-e-n-t-s';
                //
                this.translateComponent(this.topMenuComponentLink, 'app-top-menu');

                // big colorful buttons
                // this.loginFormComponentLink.news = 'NEWS';
                // this.loginFormComponentLink.buy = 'BUY';
                // this.loginFormComponentLink.read = 'READ';
                // this.loginFormComponentLink.map = 'S. MAP';
                // this.loginFormComponentLink.promo = 'PROMO';
                // this.loginFormComponentLink.events = 'EVENTS';
                // this.loginFormComponentLink.discuss = 'DISCUSS';
                // this.loginFormComponentLink.instr = 'INSTR.';

                this.homeComponentLink.changeLanguageRUColor = 'grey';
                this.homeComponentLink.changeLanguageENColor = 'black';

            } else if ('rus' === versionS) {
                // console.log('translate to rus', versionS);
                // russian version parameter initialising
                // about book
                // this.mainContentComponentLink.homePageLogo = 'assets/images/kompas2339.png';
                // this.mainContentComponentLink.alphabet = 'АЗБУКА';
                // this.mainContentComponentLink.human = 'ЧЕЛОВЕЧЕСКОЙ';
                // this.mainContentComponentLink.mind = 'ПСИХИКИ';
                // this.mainContentComponentLink.subtitle = 'флагман психологии';
                // this.mainContentComponentLink.authors = 'Н.М. Данилов и Е.В.Данилова ©';
                this.translateComponent(this.mainContentComponentLink, 'main-page');
                // // login form
                // this.loginFormComponentLink.loginform = 'ФОРМА ВХОДА';
                // this.loginFormComponentLink.mobile = 'МОБИЛЬНЫЙ ТЕЛЕФОН';
                // this.loginFormComponentLink.login = 'ВОЙТИ';
                // this.loginFormComponentLink.close = 'ЗАКРЫТЬ';
                // this.loginFormComponentLink.paysub = 'оплатить подписку';
                this.translateComponent(this.loginFormComponentLink, 'login-form');

                // social
                // this.leftPanelComponentLink.rideroButtonLink = 'https://ridero.ru/books/azbuka_chelovecheskoi_psikhiki/';
                // this.leftPanelComponentLink.rideroButtonImage = '../assets/images/button_ro_bw_1339.png';
                // this.leftPanelComponentLink.amazonButtonLink = 'https://www.amazon.com/dp/B01KXVU3NO';
                // this.leftPanelComponentLink.amazonButtonImage = '../assets/images/button_am_bw_1339.png';
                // this.leftPanelComponentLink.boomstarterButtonLink = 'https://boomstarter.ru/projects/niki/flagman_mirovoy_psihologii_-_azbuka_chelovecheskoy_psihiki?utm_source=ahm_site&utm_medium=ahm_book&utm_campaign=book_order&utm_content=1339';
                // this.leftPanelComponentLink.boomstarterButtonImage = '../assets/images/button_bs_bw_1339.png';
                // this.leftPanelComponentLink.instagramButtonLink = 'https://www.instagram.com/lifeplaning/';
                // this.leftPanelComponentLink.instagramButtonImage = '../assets/images/button_in_bw_1339.png';
                // this.leftPanelComponentLink.vkButtonLink = 'https://vk.com/ahm333';
                // this.leftPanelComponentLink.vkButtonImage = '../assets/images/button_vk_bw_1339.png';
                // this.leftPanelComponentLink.youtubeButtonLink = 'https://www.youtube.com/channel/UCRbi5fPwF2IZIh7Ho5nzVDA';
                // this.leftPanelComponentLink.youtubeButtonImage = '../assets/images/button_yt_bw_1339.png';
                // this.leftPanelComponentLink.fbButtonLink = 'http://facebook.com/NDanilov';
                // this.leftPanelComponentLink.fbButtonImage = '../assets/images/button_fb_bw_1339.png';
                this.translateComponent(this.leftPanelComponentLink, 'app-left-panel');

                // top menu
                // this.topMenuComponentLink.booksButtonMenuText = 'книги';
                // this.topMenuComponentLink.aboutButtonMenuText = 'о нас';
                // this.topMenuComponentLink.instrumentsButtonMenuText = 'и-н-с-т-р-у-м-е-н-т-ы';

                this.translateComponent(this.topMenuComponentLink, 'app-top-menu');

                // login form buttons
                // this.loginFormComponentLink.news = 'НОВОСТИ';
                // this.loginFormComponentLink.buy = 'КУПИТЬ';
                // this.loginFormComponentLink.read = 'ЧИТАТЬ';
                // this.loginFormComponentLink.map = 'КАРТА С.';
                // this.loginFormComponentLink.promo = 'ПРОМО';
                // this.loginFormComponentLink.events = 'СОБЫТИЯ';
                // this.loginFormComponentLink.discuss = 'ОБСУДИТЬ';
                // this.loginFormComponentLink.instr = 'ИНСТР.';

                this.homeComponentLink.changeLanguageRUColor = 'black';
                this.homeComponentLink.changeLanguageENColor = 'grey';

            }
        }

    }

    /**
     * todo: big page switch arrows
     */
    showPage(pageNumber) {
        this.resetComponents();
        // only positive values of page numbers
        if (pageNumber > 0) {
            // choose book version: AHM0, AHM1, AHM2, AHM3, АЧП0, АЧП1, АЧП2, АЧП3
            // todo: put here bookVersion
            let choosenBookVersionMapping: string;
            switch (this.choosenBookVersion) {
                case 'AHM1': {
                    choosenBookVersionMapping = 'ahm1eng';
                    break;
                }
                case 'АЧП1': {
                    choosenBookVersionMapping = 'ahm1rus';
                    break;
                }
                default: {
                    choosenBookVersionMapping = 'ahm1eng';
                    break;
                }
            }

            const pagesdata = this.getPagesData(choosenBookVersionMapping);
            // hide login form
            this.hideLoginForm();
            // put back button
            this.navigationComponentLink.backButtonDisplay = 'none';
            this.homeComponentLink.mainPageDisplay = 'none';
            // add ahm versions control
            let htmlText: string;
            if ('eng' === this.version) {
                htmlText =
                    '<div align="center">' +
                    '<font color="aqua" class="ahmversion" >AHM0</font>' +
                    '&nbsp;&nbsp;' +
                    '<font color="aqua" class="ahmversion" >AHM1</font>' + // todo: big controls with understanding what is active and what page choosen
                    '&nbsp;&nbsp;' +
                    '<font color="aqua" class="ahmversion" >AHM2</font>' +
                    '&nbsp;&nbsp;' +
                    '<font color="aqua" class="ahmversion" >AHM3</font>' +
                    '</div>'
                ;
                // '<component>'
            } else if ('rus' === this.version) {
                htmlText =
                    '<div align="center">' +
                    '<font color="aqua" class="ahmversion" >АЧП0</font>' +
                    '&nbsp;&nbsp;' +
                    '<font color="aqua" class="ahmversion" >АЧП1</font>' +
                    '&nbsp;&nbsp;' +
                    '<font color="aqua" class="ahmversion" >АЧП2</font>' +
                    '&nbsp;&nbsp;' +
                    '<font color="aqua" class="ahmversion" >АЧП3</font>' +
                    '</div>'
                ;
            }
            // mark book version choosen
            htmlText = htmlText.replace(this.choosenBookVersion, '[' + this.choosenBookVersion + ']');
            htmlText += pagesdata[pageNumber - 1].text;
            // replace all pattern without regular exp
            htmlText = htmlText.split('\n').join('<br/>');
            // add styles
            htmlText = '<div class="page" align="left">' + htmlText + '</div>';
            this.dynamicComponentLink.viewContent = htmlText;
            // todo: вообще лучше для этого места использовать компонент (выбор версий книги)
            setTimeout(() => {
                const bookVersionElement = this.dynamicComponentLink.element.nativeElement.querySelectorAll('.ahmversion');
                for (let i = 0; i < bookVersionElement.length; i++) {
                    // console.log('bookVersionElement', bookVersionElement);
                    const bookElementOne = bookVersionElement[i];
                    // TODO: bug with choosing book version
                    if (!true && bookElementOne) {
                        bookElementOne.addEventListener('click', () => this.chooseBook(bookElementOne));
                    }
                }
            });
        }
    }

    /**
     * Book version choosen
     *
     * @param bookVersionElement
     */
    chooseBook(bookVersionElement) {

        this.resetComponents();

        if ('[AHM1]' === bookVersionElement.innerHTML ||
            '[АЧП1]' === bookVersionElement.innerHTML) {
            // ok
        } else {
            alert('this book unavaliable');
        }
        // set choosen book for this service
        // this.choosenBookVersion = bookVersionElement.innerHTML;
        // todo: reset page number for book
        // this.topMenuComponentLink.currentPageAHM = 1;
    }

    /**
     * set book version and showPage method will automatically show selected
     *
     * @param versionOfBook - 'AHM1', 'AHM2' ... 'АЧП1', 'АЧП2' ...
     */
    setBookVersion(versionOfBook) {
        this.choosenBookVersion = versionOfBook;
    }

    /**
     * load diploms section by clicking button diploma
     */
    loadDyploms() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';

        // this.appComponentLink.mainPageDisplay = 'none';
        if ('eng' === this.version) {

            // generate html page here - english
            this.dynamicComponentLink.viewContent =
                '<div class="other-content">' +
                '<br/><br/><br/>' +
                '<h3>AHM RANGE SYSTEM</h3>' +
                '' +
                '(by ahm2 book. chapter. objective system of skills and evaluations)' +
                '<br/><br/><br/><br/>' +
                'Many graduates in psychology but only few of them have got level of psychoanalysis more then zero. Really good from them are saying. Need to know so much to understand a bit. It was before AHM classification was created. Very rude comparsion. Only this aspect. AHM classification with math. Nobody can calculate logarithms and integrals without understanding plus, minus, equals, multiply... But in psychology it is very usual when docs setting diagnosys without understanding difference between symthoms of idiotism and signs of mental health. Basic things. Root for everything in psychology.' +
                '<br/><br/><br/><br/>' +
                'It is not enough just to learn this difference. But also to make all old psychology refactoring. It is not easy and fast but very very effective.' +
                '<br/><br/><br/><br/>' +
                'So. AHM do not suppose to create new diploma. Get goverment approvement with black techniques. Like many do. And sell it to everybody. NO! May be we will continue talking about AHM diplomas later or ahm approved seal. But only after it will be 100 percent protected and clear for everyone.' +
                '<br/><br/><br/><br/>' +
                'Lets talk about new range system. We will upgrade it systematically. And one of the main aspects how to find person with low level of psychoanalysis. They can not talk fluent about sympthoms. Call sympthoms and explain situation to make it understood.' +
                '<br/><br/><br/><br/>' +
                'Market creating tones of fake psychologists with zero level of psychoanalysis. So market is good weapon. We will support and give possibilities for psychologists with good level of psychic literacy here in this page. Good clients, orders, recommendations, popularity like real professional...' +
                '<br/><br/><br/><br/>' +
                'Does not matter where. Just doing your blog with deep explanation of processes inside human psyche. Only video will be ranged. Any stroies about healing, resolving conflicts, using psychology and psychoanalysis in business, goverment, etc. AHM classification is not your enemy. Your friend.' +
                '<br/><br/><br/><br/>' +
                'find -> <img src="assets/images/button_di_color_1339.png" [style]="cursor: pointer" />' +
                '<br/><br/></div>' +
                ''
            ;
        } else if ('rus' === this.version) {

            // generate page here - russian
            this.dynamicComponentLink.viewContent =
                '<div class="other-content">' +
                '<h3>СИСТЕМА РАНГОВ АЧП</h3>' +
                '' +
                '(по книге ачп2. глава. объективная система навыков и оценок)' +
                '<br/><br/><br/><br/>' +
                'Многие выпускники в области психологии, но лишь немногие из них имеют уровень психоанализа больше нуля. Очень хорошо от них говорят. Нужно знать так много, чтобы понять немного. Это было до того, как была создана классификация AHM. Очень грубое сравнение. Только этот аспект. AHM классификация с математикой. Никто не может вычислить логарифмы и интегралы без понимания плюс, минус, равно, умножить ... Но в психологии очень часто, когда доктора ставят диагнозы, не понимая различий между симптомами идиотизма и признаками психического здоровья. Основные вещи. Болею за все в психологии.' +
                '<br/><br/><br/><br/>' +
                'Недостаточно просто изучить эту разницу. Но и сделать всю старую психологию рефакторинга. Это не легко и быстро, но очень и очень эффективно.' +
                '<br/><br/><br/><br/>' +
                'Так. АХМ не предполагает создавать новый диплом. Получите одобрение правительства с черными методами. Как многие делают. И продать его всем. НЕТ! Может быть, мы продолжим говорить о дипломах AHM позже или о одобренной печати. Но только после этого он будет на 100 процентов защищен и понятен каждому.' +
                '<br/><br/><br/><br/>' +
                'Давайте поговорим о новой системе дальности. Мы будем обновлять его систематически. И один из главных аспектов, как найти человека с низким уровнем психоанализа. Они не могут свободно говорить о симптомах. Вызовите симптомы и объясните ситуацию, чтобы она была понятна.' +
                '<br/><br/><br/><br/>' +
                'Рынок создает тоны фальшивых психологов с нулевым уровнем психоанализа. Так что рынок - это хорошее оружие. Мы будем поддерживать и предоставлять возможности для психологов с хорошим уровнем психической грамотности здесь на этой странице. Хорошие клиенты, заказы, рекомендации, популярность как настоящий профессионал...' +
                '<br/><br/><br/><br/>' +
                'Не важно где. Просто веду свой блог с глубоким объяснением процессов внутри человеческой психики. Только видео будет ранжировано. Любые разговоры об исцелении, разрешении конфликтов, использовании психологии и психоанализа в бизнесе, правительстве и т. Д. Классификация AHM не является вашим врагом. Твой друг.' +
                '<br/><br/><br/><br/>' +
                'найти -> <img src="assets/images/button_di_color_1339.png" [style]="cursor: pointer" />' +
                '<br/><br/>' +
                '</div>'
            ;

        }
    }

    /**
     * Not finished modules are showing this message
     */
    developmentAlert() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.dynamicComponentLink.viewContent =
            '<br/><br/>' +
            'THIS MODULE IN DEVELOPMENT STAGE' +
            '<br/><br/>' +
            'coming soon...';


    }

    /**
     * Home page stub
     */
    homePageContent() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'none';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.dynamicComponentLink.viewContent =
            '<br/><br/>' +
            'THIS IS HOME PAGE' +
            '<br/><br/>';
    }

    /**
     * About section
     */
    loadAboutContent() {

        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'about';
        this.homeComponentLink.dynamicPageDisplay = 'none';

        // this.resetComponents();
        // // hide login form
        // this.hideLoginForm();
        // // put back button
        // this.navigationComponentLink.backButtonDisplay = 'block';
        // this.homeComponentLink.mainPageDisplay = 'none';
        // // choose language
        // if ('eng' === this.version) {
        //     // English Version
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'ABOUT AHM' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">In brief.</font> AHM is continue of psychology as a science that changed epoch.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">For different</font> types of personality same event or case will cause different or opposite processes inside the psyche. That’s why starting psychoanalysis from something, but identifying types of personality, - glaring mistake.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">First famous</font> classification was from Karl Gustav Jung. But not full. Only few concepts. Not enough.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Other important</font> step was made by Myers — Briggs Type Indicator (MBTI). They made Karl classification wider and got many types of personality. Every top manager of big company got this subject in education program for highest management. But basics of MBTI were not accurate and precise from scientific point of view. So. This classification does not accumulate all power of psychoanalysis.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">And AHM does!</font> Basics were right and all process inside human psyche became clear and easy to understand, write or draw in the scheme / graph.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Really skilled</font> professionals are agree in one thing. Person need to know so much to understand just a bit in psychology. AHM classification encapsulted all this \'too much\' and barriers in psychology became very low with AHM. But possibilities and power of use may be upgraded up to infinity.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Does not matter</font> if you are professional psychologist/psychiatrist. Or top manager of billion scale company on the Wall Street. Psychoanalysis is key skill you need. And can be upgraded very much with visible effect. This site for everyone really successful or what to be. All top instruments, professionals, communities, conventions and resources here. Based on the most powerful, accurate and full classification of personality types by AHM.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Very popular direction</font> today to handle everything connected with Your own psyche: growing, healing, goals achievement, personal therapy, recovering therapy... It is reality today. All effective methodics and instruments are based on AHM classification. And all processes inside psyche are clear and understood for every action or event. It is unique and super important advantage avaliable only by AHM.' +
        //         '</div>' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font size="5" class="text_w"><b>WELCOME TO AHM</b></font>' +
        //         '<br/><br/>';
        // } else if ('rus' === this.version) {
        //     // Russian Language
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'ОБ АЧП' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Вкратце.</font> АЧП - это продолжение психологии как науки, которое изменило эпоху.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Для разных</font> типов личности одно и то же событие или случай вызовет разные или противоположные процессы внутри психики. Вот почему начинать психоанализ, не выявляя типы личности участников, - грубая ошибка.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Первая научная</font> и популярная классификация была от Карла Густава Юнга. Но она была не полной. Только несколько понятий. Недостаточно.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Другой важный</font> для науки шаг был сделан типологией Майерс — Бриггс. Они расширили классификацию Карла и получили много типов личности. Каждый топ-менеджер крупной компании изучал этот предмет в образовательной программе для высшего руководства. Но основы MBTI не были точными с научной точки зрения. Поэтому классификация MBTI не содержит в себе всю силу психоанализа.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">А вот АЧП</font> содержит! Базовые понятия были правильными. Благодаря этому все процессы в человеческой психике стали ясными и простыми для понимания, написания или рисования на схеме / графике.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Действительно квалифицированные</font> специалисты согласны в одном. Человек должен знать очень много, чтобы хоть немного понимать в человеческой психике. Классификация АЧП инкапсулирует в себе все это «слишком много». Барьеры в психологии стали очень низкими с классификацией АЧП. Но повышение уровня психоанализа и сопутствующих навыков, а также мощь использования, могут быть доведены до бесконечности.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Не имеет значения.</font> Вы профессиональный психолог / психиатр. Или топ-менеджер миллиардной компании на Уолл-стрит. Психоанализ - это ключевой навык, который вам нужен. И может быть сильно улучшен с видимым эффектом. Этот сайт для всех действительно успешных. И для тех, кто хочет быть успешным. Все лучшие инструменты, профессионалы, сообщества, конвенции и ресурсы здесь. На основе самой мощной, точной и полной классификации типов личности АЧП.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Сегодня очень</font> популярное направление - брать под контроль все, что связано с Вашей собственной психикой: личный рост, лечение, достижение целей, личная терапия, восстановительная терапия ... Это реальность сегодня. Все эффективные методики и инструменты основаны на классификации АЧП. И все процессы внутри психики ясны и понятны в контексте каждого действия или события. Это уникальное и очень важное преимущество, доступное только АЧП.' +
        //         '</div>' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font size="5" class="text_w"><b>ДОБРО ПОЖАЛОВАТЬ В АЧП</b></font>' +
        //         '<br/><br/>';
        // }
    }

    /**
     * Donate section
     */
    donateContentBlock() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        this.dynamicComponentLink.sliderHidden = false;
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        // choose language
        if ('eng' === this.version) {
            // English Version
            this.dynamicComponentLink.viewContent =
                '<br/><br/>' +
                '<font size="5" class="text_bw_title">' +
                'SUPPORT AHM PROJECTS' +
                '</font>' +
                '<div align="left">' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• if u want to use best instruments and other resources' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• read books in your own language faster' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• read / listen / watch more versions / formats of books' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• and u not out of money' +
                '</div>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<font size="6" class="text_bw_title">donate AHM projects and books is easy:</font>' +
                '<br/><br/>' +
                //'<font size="9">' +
                //'<a href="https://paypal.me/nikitadanilov?locale.x=en_EN" target="_blank" class="text_w">Donate AHM >></a>' +
                //'</font>' +
                '<br/><br/>';
        } else if ('rus' === this.version) {
            // Russian Language
            this.dynamicComponentLink.viewContent =
                '<br/><br/>' +
                '<font size="5" class="text_bw_title">' +
                'ПОДДЕРЖАТЬ АЧП ПРОЕКТЫ' +
                '</font>' +
                '<div align="left">' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• если вы хотите использовать лучшие инструменты и другие ресурсы в высоком качестве' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• читать книги на вашем родном языке быстрее' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• читать / слушать / смотреть больше версий / форматов книг' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• и деньги есть' +
                '</div>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<font size="6" class="text_bw_title">поддержать проекты и книги АЧП легко:</font>' +
                '<br/><br/>' +
                //'<font size="9">' +
                //'<a href="https://paypal.me/nikitadanilov?locale.x=ru_RU" target="_blank" class="text_w">Поддержать АЧП >></a>' +
                //'</font>' +
                '<br/><br/>';
            ;
        }
    }

    /**
     * Read section
     */
    readContentBlock() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.pa
        // choose language
        if ('eng' === this.version) {
            // English Version
            this.dynamicComponentLink.viewContent =
                '<br/><br/>' +
                '<font size="5" class="text_bw_title">' +
                'Read books AHM series' +
                '</font>' +
                '<div align="left">' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• some books and chapters of the AHM series can be read on this site for free. either buy a subscription and read all books in all languages' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• the first chapters of books of the AHM series can be read for free on the websites of online stores where books are sold' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• books in electronic format can be purchased at sites: the labyrinth (labirint.ru), liters (litres.ru), RiderÓ (ridero.ru/books/), Amazon (amazon.com), ozone (ozon.ru) and other' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• paper versions of books are sold in stores: Books House St. Petersburg (spbdk.ru), Bookvoed (bookvoed.ru), Reading City (chitai-gorod.ru), Books and Gifts, and many others' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• exclusive editions and editions with signatures of the Authors can be purchased at specialized outlets. best to use internet search' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• in Russian libraries. make a request before the visit' +
                '</div>' +
                '<br/><br/>' +
                '<br/><br/>';
        } else if ('rus' === this.version) {
            // Russian Language
            this.dynamicComponentLink.viewContent =
                '<br/><br/>' +
                '<font size="5" class="text_bw_title">' +
                'Читать книги серии АЧП' +
                '</font>' +
                '<div align="left">' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• некоторые книги и главы серии АЧП можно прочитать на этом сайте бесплатно. либо купить подписку и читать все книги на всех языках' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• первые главы книг серии АЧП можно прочитать бесплатно на сайтах интернет-магазинах, где продаются книги' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• книги в электронном формате можно купить на сайтах: лабиринт (labirint.ru), литрес (litres.ru), ридеро (ridero.ru/books/), амазон (amazon.com), озон (ozon.ru) и других' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• бумажные версии книг продаются в магазинах: Дом Книги Спб (spbdk.ru), сети Буквоед (bookvoed.ru), Читай Город (chitai-gorod.ru), Книги и Подарки и многих других' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• эксклюзивные издание и издания с подписями Авторов можно приобрести в специализирванных торговых точках. лучше всего использовать поиск в интернет' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• в Российских библиотеках. перед визитом сделайте запрос о наличие' +
                '</div>' +
                '<br/><br/>' +
                '<br/><br/>';
        }
    }

    /**
     * Buy books section
     */
    buyContentBlock() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'buy';
        this.homeComponentLink.dynamicPageDisplay = 'none';
        // choose language
    }

    /**
     * News section
     */
    newsContentBlock() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'news';
        this.homeComponentLink.dynamicPageDisplay = 'none';
        // this.resetComponents();
        // // hide login form
        // this.hideLoginForm();
        // // put back button
        // this.navigationComponentLink.backButtonDisplay = 'block';
        // this.homeComponentLink.mainPageDisplay = 'none';
        // // choose language
        // if ('eng' === this.version) {
        //     // English Version
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'News of AHM book series' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">10.04.2019</font> - Book AHM1 can be purchased in the largest book network of Russia \'Bookvoed\'!' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">22.03.2018-10:37</font> - Book AHM1 can be purchased at the "Book House Spb" bookstore!' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">28.11.2017-12:50</font> - Non / fiction 2017, Russia, Moscow! AHM1 is presented at this event.' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">18.10.2017-12:00</font> - The first news is added! The "News" section on the AHM official website has been created!' +
        //         '</div>' +
        //         '<br/><br/>' +
        //         '<br/><br/>';
        // } else if ('rus' === this.version) {
        //     // Russian Language
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'Новости серии книг АЧП' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Начало Зимы 2020</font> - Вышла долгожданная версия 2.1 серии АЧП. АЧП2: глобальная психотерапия. Купить можно несколькими способами. Заказ на сайте. В интернет магазинах. <a href="https://www.ozon.ru/context/detail/id/169547583/" target="_blank" style="color: white;">Купить АЧП2.1 на OZON</a>' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">10.04.2019</font> - Книгу АЧП1 можно приобрести в крупнейшей книжной сети России \'Буквоед\'!' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">22.03.2018-10:37</font> - Книгу АЧП1 можно приобрести в книжном магазине \'Дом Книги\'!' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">28.11.2017-12:50</font> - Non/fiction 2017, Russia, Moscow! АЧП1 презентуется на этом мероприятие.' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">18.10.2017-12:00</font> - Добавлена первая новость! Раздел "Новости" на официальном сайте АЧП создан!' +
        //         '</div>' +
        //         '<br/><br/>' +
        //         '<br/><br/>';
        // }
    }

    /**
     * Instruments section
     */
    instrumentsContent() {

        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'instruments';
        this.homeComponentLink.dynamicPageDisplay = 'none';

        // this.resetComponents();
        // // hide login form
        // this.hideLoginForm();
        // // put back button
        // this.navigationComponentLink.backButtonDisplay = 'block';
        // this.homeComponentLink.mainPageDisplay = 'none';
        // // choose language
        // if ('eng' === this.version) {
        //     // English Version
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'AHM INSTRUMENTS' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         'The most important tool is the understanding of the AHM classification and skills, ' +
        //         'which are based on this classification. Nevertheless, there are already tools that ' +
        //         'greatly simplify many aspects or increase accuracy, efficiency, impact force, etc. ' +
        //         'The more practice the better.' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '• <font class="text_bw_title">Tests</font><br/><br/>' +
        //         'The complex of automatic and semi-automatic tests. Which help to better determine the psycho-types of participants in an event or group. Others and personal. Increase the accuracy of psychoanalysis. Personal (self-examination) and others.' +
        //         '<br/><br/>' +
        //         'In developing...' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '• <font class="text_bw_title">Mental flowchart editor</font> <font class="psyModelerLink"><b>PSY-Modeler (Desktop)</b></font><br/><br/>' +
        //         'The first flowchart in the history of psychology, which represented the psycho-types of people and / or group / team. As well as the flows of aggression, as the main symptom and other symptoms was presented by the authors of the AHM. In the book AHM2 there is a specification for the construction of mental or aggressive flowcharts. Many newcomers to AHM have already heard a lot, that any psychoanalysis must begin with the most accurate definition of psycho-types for the participants of the event. Otherwise, this type of psychoanalysis cannot even be considered unsatisfactory. Because the same events for different types of personality cause different and opposite processes in the psyche ... The psychic flowchart takes the understanding of the processes in the psyche to a new level. And how do these processes affect the psyche of other psycho-types.' +
        //         '<br/><br/>' +
        //         'In developing...' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '• <font class="text_bw_title">AHM Events</font><br/><br/>' +
        //         'AHM events are not only interesting. But also very much help to up/improve your skills. An event such as "Psycho Type In 3 Seconds", for example, is a very good workout in the form of a game for FBI officers. They need to know the type of personality of a potential criminal for the minimum time. Sometimes, it only has 3 seconds. And this is the real situation. For the store manager, this game is also very useful in order to determine the psycho type of the buyer as soon as possible and send him the best of the psycho types of employees. This will help avoid the conflict of psychtypes and other types of conflicts, and thus increase the chance of success purchase and profit of the store.' +
        //         '<br/><br/>' +
        //         'For events there is a separate section in the site menu.' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '</div>';
        // } else if ('rus' === this.version) {
        //     // Russian Language
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'ИНСТРУМЕНТЫ АЧП' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         'Самый важный инструмент - это понимание классификации АЧП и умения, которые базируются на этой классификации.' +
        //         ' Тем не менее уже существуют инструменты, которые сильно упрощают многие моменты или увеличивают точность,' +
        //         ' эффективность, силу воздействия и т.п.' +
        //         ' Чем больше практики, тем лучше.' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '• <font class="text_bw_title">Тесты</font><br/><br/>' +
        //         'Комплекс автоматических и полуавтоматических тестов. Которые помогают лучше определить психотипы участников события или группы.' +
        //         ' Окружающих и свой личный. Увеличивают точность психоанализа. Личного (самоанализ) и окружаюущих.' +
        //         '<br/><br/>' +
        //         'В разработке...' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '• <font class="text_bw_title">Редактор психических блок-схем</font> <font class="psyModelerLink"><b>PSY-Modeler (Desktop)</b></font><br/><br/>' +
        //         'Первую блок-схему в истории психологии, на которой были представлены психотипы людей и/или группы/коллектива. А также потоки агрессии, как основной симптом и других симптомов представили авторы АПЧ. В книге АЧП2 есть спецификация по построению психических или агрессивных блок-схем. Многие новички АЧП уже много слышали, что любой психоанализ должен начинаться с максимально точного определения психотипов для участников данного события. Иначе данный вид психоанализа не может считаться даже удовлетворительным. Т.к. одинаковые события для разных типов личности вызывают разны и противоположные процессы в психике... Психическая блок-схема переводит понимание процессов в психике на новый уровень. И как эти процессы влияют на психику других психотипов.' +
        //         '<br/><br/>' +
        //         'В разработке...' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '• <font class="text_bw_title">События АЧП</font><br/><br/>' +
        //         'События АЧП не только инетресны. Но и очень сильно помогают прокачать/улучшить свои навыки/скиллы. Такое событие, как "Психотип За 3 секунды", к примеру, очень хорошая тренировки в игровой форме для сотрудников ФСБ. Им надо знать тип личности потенциального преступника за минимальное время. Иногда, на это есть всего 3 секунды. И это реальная ситуация. Для менеджера магазина также эта игра очень полезна чтобы как можно скорее определить психотип покупателя и отправить к нему лучший из психотипов сотрудников. Это поможет избежать конфликта психтипов и других конфликтов при покупки, а значит увеличит шанс успеха и прибыль магазина.' +
        //         '<br/><br/>' +
        //         'Для событий выделена отдельная секция в меню сайта.' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '</div>';
        // }
    }

    /**
     * load events content and choose language
     */
    eventsContent() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        // choose language
        if ('eng' === this.version) {
            // English Version
            this.dynamicComponentLink.viewContent =
                '<br/><br/>' +
                '<font size="5" class="text_bw_title">' +
                'AHM EVENTS' +
                '</font>' +
                '<div align="left">' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Psychotype In 3 Seconds</font><br/><br/>' +
                '<div align="center"><img src="assets/images/events/psyin3sec/title_img_1339.jpg" class="events_img"></div>' +
                '<br/><br/>' +
                '→ DESCRIPTION: Determine the psychotype of others in the shortest possible time and figure out how this can be used in different situations.' +
                '<br/><br/>' +
                '→ RULES: To find out type of human personality in minimum time and maximim precision. And post it in instagram with Your own words and proves: videos, photos. By tag #PT3S. Better to use for it classification AHM1, AHM2, but up to You!' +
                '<br/><br/>' +
                '→ PLACE: Everywhere! In metro, driving car, in caffe, wathcing famous movie say everyone what type of personalyty has main character. Deeper understanding - more interest! With interesting psycotype, or 1 million/billion dollars psychotype You may try to start relationship and post video how it was!' +
                '<br/><br/>' +
                '→ TIME: Every two weeks. Starts evening friday, ends night sunday with or without alert!' +
                '<br/><br/>' +
                '→ REWARDS: You have chance to win luxury rewards in the way of amazing surprise! Pure psychoanalysis! High lvl of psychic literacy!' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Fallen PPMs</font><br/><br/>' +
                '<div align="center"><img src="assets/images/events/fallenppms/fallenppms.jpg" class="events_img">' +
                '<br/>etsy.com ©' +
                '</div>' +
                '<br/><br/>' +
                '⚡ SITUATION: The PPM is a Particularly Primitive type of Mind, the root and cause of mental disorders. Having defeated PPM, mental illness goes away. Today, the epidemic of the PPM or the epidemic of the mentally ill, is in full swing! AHM was the first to prove this and described an effective fight against the Horrible Epidemic (see AHM2). Since childhood, the Child is among the streams of aggression, which are formed in different ways and schemes. All the scientific schemes are in the books of the AHM series and related resources.' +
                '<br/><br/>' +
                '⚡ DESCRIPTION: In such a situation, many people encounter simple and complex symptoms (mental scenarios) already in adulthood and many situations recur. Of course, each case is unique and someone more fortunate with the family, there was no uncle / grandmother with daily attacks of aggression, which turned into various crimes. Someone less fortunate. Someone was prettier and others simply couldn’t figure out how to humiliate dignity. Someone was strong, they were afraid ... But the flow of aggression is too strong to avoid them completely. More over personal aggression goes into collective or even folk aggression. All schemes are avaliable by #AHM. Everyone in life had a situation that caused mental trauma. Until the psyche could overcome this situation even mentally. The trauma will not go anywhere and will sit in the depths of the subconscious. Not allowing to develop yourself and achieve success.' +
                '<br/><br/>' +
                '⚡ GOAL: In any way to beat the past mental trauma. So to become the winner! You can change the names of the situation. You can draw, you can shoot a video: thumbnail or full-length. By working on this situation, you will force the psyche to heal the trauma at all levels.' +
                '<br/><br/>' +
                '⚡ EXAMPLE: Write a dialogue, as you would not insult yourself to PPM and put in his/her place. Out of your reality f.e.' +
                '<br/><br/>' +
                '⚡ RULES: Every last day of the month it is necessary to create a post and submit it on Instagram with the tag #fp_event. Responding aggression must be turned into socially acceptable. Simply using it effectively in a real situation.' +
                '<br/><br/>' +
                '⚡ AWARDS: Improving the level of mental literacy: personal and public. It is very important to fight the horrible epidemic. Strengthening the psyche. The rating of participants TOP10 will receive awards!' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Flashmob AHM PRO</font><br/><br/>' +
                '<div align="center">' +
                '<img src="assets/images/events/photovideo/ahmeng.jpg" class="events_img">' +
                '</div>' +
                '<br/><br/>' +
                'Flashmob #AHMPRO goes! Join!' +
                '<br/><br/>' +
                'Rules are simple - the most original photo/video with book/ebook or AHM logo.' +
                '<br/><br/>' +
                'It is chance to win luxury rewards!' +
                '<br/><br/>' +
                '</div>';
        } else if ('rus' === this.version) {
            // Russian Language
            this.dynamicComponentLink.viewContent =
                '<br/><br/>' +
                '<font size="5" class="text_bw_title">' +
                'АЧП СОБЫТИЯ' +
                '</font>' +
                '<div align="left">' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Психотип За 3 Секунды</font><br/><br/>' +
                '<div align="center"><img src="assets/images/events/psyin3sec/title_img_rus_1339.jpg" class="events_img"></div>' +
                '<br/><br/>' +
                '→ ОПИСАНИЕ: Определить психотип окружающих за минимальное время и придумать, как это можно использовать в разных ситуациях.' +
                '<br/><br/>' +
                '→ ПРАВИЛА: Определить психотип за минимальное время с максимальной точностью. И описать это своими словами с подтверждениями - фото, видео в публикации Инстаграм с тегом #ПТ3С. Лучше использовать для этого классификацию АЧП1, АЧП2, но зависит от Вас!' +
                '<br/><br/>' +
                '→ МЕСТО: Везде! В общественных местах, за рулём, в кафе, просматривая популярные фильмы и сериалы - расскажите каждому какой же психотип у главного героя и почему! Глубже понимание - интересней! Если повстречается интересный психотип или психотип на миллион/миллиард долларов, то можно познакомиться и попытаться построить отношения, а также выложить интересный пост об этом!' +
                '<br/><br/>' +
                '→ ВРЕМЯ: Каждые две недели, начало вечером в пятницу, окончание в ночь воскресенья! Это обновление регулярного флэшмоба "Устойчивый Ли Ты Психотип?" Начинается с оповещением или без!' +
                '<br/><br/>' +
                '→ НАГРАДЫ: Это шанс выиграть роскошные награды, которые окажутся сюрпризом! Чистый психоанализ! Высокий уровень психической грамотности!' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Павшие КПМы</font><br/><br/>' +
                '<div align="center"><img src="assets/images/events/fallenppms/fallenppms.jpg" class="events_img">' +
                '<br/>etsy.com ©' +
                '</div>' +
                '<br/><br/>' +
                '⚡ СИТУАЦИЯ: КПМ - это Конкретно-Примитивный тип Мышления, корень и причина психических расстройств. Победив КПМ, душевная болезнь уходит. Сегодня Эпидемия КПМ или эпидемия душевнобольных, идёт полным ходом! АЧП первыми доказали это и описали эффективную борьбу со Страшной Эпидемией (по АЧП2). С самого детства Ребенок оказывается среди потоков агрессии, которые формируются разными способами и схемами. Все научные схемы и обоснования есть в книгах серии АЧП и сопутствующих ресурсах.' +
                '<br/><br/>' +
                '⚡ ОПИСАНИЕ: В такой ситуации множество людей встречают простейшие и сложные симптомы (психические сценарии) уже во взрослой жизни и многие ситуации повторяются. Конечно, каждый случай уникален и кому-то больше повезло с семьёй, там не было дяди/бабушки с ежедневными приступами агрессии, которые переходили в различные преступления. Кому-то повезло меньше. Кто-то был красивее и придумать как унизить достоинство просто не смогли, кто-то сильным, боялись... Но потоки агрессии слишком сильны чтобы полностью их избежать, тем более, личная агрессия очень просто переходит в коллективную и народную. Все схемы ищите #АЧП. У каждого в жизни была ситуация, которая нанесла травму психики. До тех пор, пока психика не смогла эту ситуацию преодолеть даже мысленно, травма никуда не денется и будет сидеть в глубине подсознания, не давая развиваться и достигать успеха.' +
                '<br/><br/>' +
                '⚡ ЦЕЛЬ: Любым способом обыграть прошлую травму психики. Так чтобы выйти Победителем! Можно менять имена, обстановку. Можно нарисовать, можно снять видео: миниатюру или полнометражное. Работая над этой ситуацией, Вы заставите психику залечивать травму на всех уровнях.' +
                '<br/><br/>' +
                '⚡ ПРИМЕР: Напишите диалог, как Вы не дали бы себя оскорбить КПМу и поставили на место.' +
                '<br/><br/>' +
                '⚡ ПРАВИЛА: Каждый последний день месяца необходимо выложить публикацию в Инстаграм с тегом #пк_событие. Ответную агрессию необходимо превратить в социально приемлемую. Такую, которую можно было бы использовать эффективно в реальной ситуации.' +
                '<br/><br/>' +
                '⚡ НАГРАДЫ: Повышение уровня психической грамотности: личной и общественной. Это очень важно для борьбы со Страшной Эпидемией. Укрепление психики. Рейтинг участников ТОП10 получат награды!' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Флэшмоб АЧП ПРО</font><br/><br/>' +
                '<div align="center">' +
                '<img src="assets/images/events/photovideo/ahm.jpg" class="events_img">' +
                '</div>' +
                '<br/><br/>' +
                'Флэшмоб #АЧППРО продолжается!' +
                '<br/><br/>' +
                'Присоединяйся!' +
                '<br/><br/>' +
                'Правила просты - самое оригинальное фото/видео с книжкой АЧП печатной/электронной или логотипом.' +
                '<br/><br/>' +
                'Это шанс выиграть роскошные награды!' +
                '<br/><br/>' +
                '</div>';
        }

    }

    /**
     * support section
     */
    supportContent() {
        this.resetComponents();
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'support';
        this.homeComponentLink.dynamicPageDisplay = 'none';
        // this.resetComponents();
        // // hide login form
        // this.hideLoginForm();
        // // put back button
        // this.navigationComponentLink.backButtonDisplay = 'block';
        // this.homeComponentLink.mainPageDisplay = 'none';
        // // choose language
        // if ('eng' === this.version) {
        //     // English Version
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'SITE SUPPORT' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Write to e-mail:</font> support@ahm-pro.com<br/><br/>' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         'Answer may take 24h or more. This is site support. Not psychological support.' +
        //         '<br/><br/>' +
        //         '</div>';
        // } else if ('rus' === this.version) {
        //     // Russian Language
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'ПОДДЕРЖКА САЙТА' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Пишите на e-mail:</font> support@ahm-pro.com<br/><br/>' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         'Ответ может занять 24 часа и больше. Это поддержка сайта. Не психологическая помощь.' +
        //         '<br/><br/>' +
        //         '</div>';
        // }
    }

    /**
     * find psy section
     */
    psyContent() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        // choose language
        if ('eng' === this.version) {
            // English Version
            this.dynamicComponentLink.viewContent =
                '<br/><br/>' +
                '<font size="5" class="text_bw_title">' +
                'FIND PSYCOLOGIST' +
                '</font>' +
                '<div align="left">' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<font class="text_bw_title">PSY Team effective.</font> Find good psychologist, psychiatrist or psychotherapist in 2016 was very big problem. Psychology before AHM was created was science of denials. ' +
                'Very briefly. Lobotomy (nailing a nail into the brain) was recognized as not a treatment method and all subsequent (in time) prcedures gradually, too. Many procedures before 2016, used by official medicine, also were not treatment. ' +
                'But difficult to refute because it is very deep conversation about neurotransmitters and other receptors... ' +
                'The main impacts are precisely in this area, but this does not violate the rights of the patient and cause no less harm to the health of the body and psyche than using a lobotomy and similar procedures.' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<font class="text_bw_title">----->></font>Here included best professionals from all over the world you can contact or find next to your home. They understand difference between symptoms of PPM and signs of helthy mind. ' +
                'Also, processes insight human mind. But healing or other type of psychoanalysis still very hard. Teams are very effective.' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Psychologist</font> - main task to find out psychology picture in general using conflict schemes medicine polls...' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Psychiatrist</font> - main task to find out mapping between processes in psyche and in body. ' +
                ' Working with biochemical balance in human brain. Not always required or partially.' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Psychotherapist</font> - in AHM everybody must to upgrade own level of psychoanalysis and level ' +
                'of psychoterapy (impact on the psyche). And use adaptive psychotherapy like main therapy. A lot of situations where psychotherapy ' +
                'required. And not enough time for all. Adaptive means. Using integrated therapy and achieving life/bussiness/community goals. ' +
                'Psychotherapist role is to help configure adaptive self psycotherapy ad help in difficult questions.' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Conflicts resolver</font> - almost all symptoms are result of some kind of conflict. In difficult situations ' +
                'destabilization of the psyche moves into biochemical imbalance. Draw and explain all conflicts were and are on scheme. In job/family/other ' +
                'group or place. What types of personality and flows of aggression and other symptoms. Healing without understanding root of injuries like ' +
                'snakebite treatment but again and again without taking the poisonous snake out of the pants.' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Sexologist</font> - it is well known role. But if we are talking about psychology need to start from processes' +
                ' insight human mind and human brain sometimes. A lot of problems, symptoms and injures connested with people intimate relationships.' +
                '<br/><br/>' +
                '<br/><br/>' +
                // todo: integrate language support from i18n here
                '<u>Find Your PSY:</u>  ' +
                ' <font class="text_bw_title_pointer">PSY Team</font>' +
                ' <font class="text_bw_title_pointer">Psychologist</font>' +
                ' <font class="text_bw_title_pointer">Psychiatrist</font>' +
                ' <font class="text_bw_title_pointer">Conflicts resolver</font>' +
                ' <font class="text_bw_title_pointer">Sexologist</font>' +
                '' +
                '<br/><br/>' +
                '<br/><br/>' +
                '</div>';
        } else if ('rus' === this.version) {
            // Russian Language
            this.dynamicComponentLink.viewContent =
                '<br/><br/>' +
                '<font size="5" class="text_bw_title">' +
                'НАЙТИ ПСИХОЛОГА' +
                '</font>' +
                '<div align="left">' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<font class="text_bw_title">PSY команды эффективны.</font> Найти хорошего психолога, психиатра или психотерапевта в 2016 году было очень большой проблемой. Психология до создания АЧП была наукой опровержений. Очень кратко. Лоботомия (вбивание гвоздя в мозг) была признана не методом лечения, и все последующие процедуры также постепенно опреовергнуты. Многие процедуры до 2016 года, используемые официальной медициной, также не являлись лечением. Но их сложно опровергнуть, потому что это очень глубокий разговор о нейромедиаторах и других рецепторах... Основные воздействия именно в этой области, но от этого нарушется не меньше прав пациента и причниняется не меньше вреда здоровью тела и психики, чем при использовании лоботомии и подобных процедур.' +
                '<br/><br/>' +
                '<br/><br/>' +
                '<font class="text_bw_title">----->></font>Здесь представлены лучшие специалисты со всего мира, с которыми вы можете связаться или найти рядом с вашим домом. Они понимают разницу между симптомами КПМ и признаками здоровой психики. Кроме того, процессы приисходящие в человеческой психике. Но лечение или другой тип психоанализа все еще очень сложный и затратный процесс. Команды очень эффективны.' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Психолог</font> - основная задача выяснить психологическую картину в целом с использованием конфликтных схем и медицинских опросов...' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Психиатр</font> - основная задача. Выяснить, как соотносятся процессы в психике и цнс. Сделать мэппинг этих процессов. Работа с биохимическим балансом в мозге человека. Не всегда требуется или частично.' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Психотерапевт</font> - в АЧП каждый должен повышать свой уровень психоанализа и уровень психотерапии (влияние на психику). И использовать адаптивную психотерапию как основную терапию. Много ситуаций, когда требуется психотерапия. И не хватает времени для всех. Адаптивные средства. Использование комплексной терапии и достижение жизненных/деловых/общественных целей. Роль психотерапевта заключается в том, чтобы помочь настроить адаптивную самопсихотерапию и помочь в сложных вопросах.' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Конфликтолог</font> - почти все симптомы являются результатом какого-то конфликта. В сложных ситуациях дестабилизация психики переходит в биохимический дисбаланс. Нарисовать и объяснить все конфликты, которые были и есть на схеме. В работе/семье/другой группе или месте. Какие типы личности и потоки агрессии и других симптомов активировали какие процессы в психике участников и в какой стадии... Лечение без понимания причины травм, сравнимо с лечением от укуса змеи снова и снова. Не вынимая ядовитую змею из штанов.' +
                '<br/><br/>' +
                '• <font class="text_bw_title">Сексолог</font> - это хорошо известная роль. Но если мы говорим о психологии, нужно начинать с процессов проходящих в человеческой психике и человеческом мозге. Множество проблем, симптомов и травм связано с интимными отношениями людей.' +
                '<br/><br/>' +
                '<br/><br/>' +
                // todo: integrate language support from i18n here
                '<u>Найди Своего PSY:</u>  ' +
                ' <font class="text_bw_title_pointer">PSY Команда</font>' +
                ' <font class="text_bw_title_pointer">Психолог</font>' +
                ' <font class="text_bw_title_pointer">Психиатр</font>' +
                ' <font class="text_bw_title_pointer">Конфликтолог</font>' +
                ' <font class="text_bw_title_pointer">Сексолог</font>' +
                '' +
                '<br/><br/>' +
                '<br/><br/>' +
                '</div>';
        }
    }

    /**
     * convention section
     */
    conventionContent() {
        this.resetComponents();
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'convention';
        this.homeComponentLink.dynamicPageDisplay = 'none';
        // // hide login form
        // this.hideLoginForm();
        // // put back button
        // this.navigationComponentLink.backButtonDisplay = 'block';
        // this.homeComponentLink.mainPageDisplay = 'none';
        // // choose language
        // if ('eng' === this.version) {
        //     // English Version
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'PSY CONVENTION' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">What is it? PSY Convention. For whom and why?</font> In general psy convention upgrades every year. In the last moth of the year final version approved. Conventions different with year option. If we are talking about psy convention without year. It means. Upgrading the last version of convention. All top world specialist in areas connected to human psyche are working on it. ' +
        //         'A lot of problems in every area connected to human psyche. In medicine, life, relations, family building, business and others. Most of them are result of low level of individual/group/global psychoanalysis and psychology in general. One of the biggest problem, is epidemy of PPM. Almost impossible to grow in modern world without serious psyche injuries and diagnosis as a result. ' +
        //         '<br/><br/>' +
        //         'Main golas of psy convention:' +
        //         '<br/>' +
        //         '• help individuals non professionals to upgrade skills connected to psychology' +
        //         '<br/>' +
        //         '• help individuals professionals to upgrade skills and stop doing mistakes' +
        //         '<br/>' +
        //         '• help upgrade level of psychoanalysis in communities globally' +
        //         '<br/>' +
        //         '• help to protect human rights in treatment using different methods: globally, locally' +
        //         '<br/>' +
        //         '• fighting with epidemy of ppm and reinforce/help others locally/globally' +
        //         '<br/>' +
        //         '• and others improving quality of helthcare helping to grow good professionals and protect human rights in treatment' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">PSY Convention 2018:</font>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">PSY Convention 2018. Point 1.</font> Separation of powers' +
        //         '<br/>' +
        //         'very often the diagnosis is subjective and erroneous. which is already a crime and prevents thinking about the wrong diagnosis, as well as fear for personal reputation. These factors, and often the same level of psychoanalysis and their own bunch of symptoms, make it almost impossible to correct the diagnosis on the voluntary initiative of the employee who made a mistake. it is necessary to deprive the power of medical workers to violate the constitutional rights of a person and send them for mandatory treatment of a non-existent or erroneous disease. violation of constitutional rights can be only by a court decision when it comes to crimes committed because of the symptoms. for example, attempts to bring to suicide or incitement of hostility, if the motive of these crimes were symptoms of mental illness. summary: deprive the illegal power of medical workers, which is actually used to commit a multitude of crimes from the Criminal Code of the Russian Federation. to make the procedure of state hospitalization completely transparent and without fail to check for violation of 293, 126, 110 articles of the criminal code of the Russian Federation' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">PSY Convention 2018. Point 2.</font> Start from psychoanalysis - always' +
        //         '<br/>' +
        //         'different types of personality are characterized by different processes in the psyche. the same circumstances and/or influence can cause completely different and/or opposite mental processes in different types of personality. not taking this into account is a very gross and popular mistake. most often, a conscious, predictable effect on the psyche without this stage is impossible. summary: always begin with the analysis of not only the patient or client but also the most accurate psychoanalysis of the persons with whom he/she contacts. very often, a properly formulated condition is 90% of the solution.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">PSY Convention 2018. Point 3.</font> Clear Cause-Effect Relationship' +
        //         '<br/>' +
        //         'A lot of subjective theories and points of view today are called psychology. most of them are based on the painful, not systematic experience that the author of a particular theory has experienced. All these theories are not science, because they have no causal relationships. This is misleading. the science of the human psyche, psychology has clear and transparent causal relationships. only those methods can be used in which the causal effect is fully traced. otherwise, that\'s all. but not the science of the human psyche - psychology. it could be philosophy, mysticism, fraud, etc. Summary: In any statement, a causal connection to the basic processes in the psyche should be traced.' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Please login to see and work on other points of PSY Convention 2019 before they will be finilised.</font>' +
        //         '</div>';
        // } else if ('rus' === this.version) {
        //     // Russian Language
        //     this.dynamicComponentLink.viewContent =
        //         '<br/><br/>' +
        //         '<font size="5" class="text_bw_title">' +
        //         'КОНВЕНЦИЯ МИРОВОЙ ПСИХОЛОГИИ' +
        //         '</font>' +
        //         '<div align="left">' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Что это? PSY-Конвенция. Для кого и зачем?</font> В общем и целом PSY-Конвенция обновляется каждый год. В последнем месяце года окончательный вариант утверждается. После этого к конвенции прикрепляется год принятия и это становится версией. Если мы говорим о PSY-Конвенции без года. Это значит. Идет обновление последней версии конвенции. Над этим работают все ведущие мировые специалисты в областях, связанных с психикой человека. Много серьезные проблемы в разных сферах, связаны с психикой человека. В медицине, жизни, отношениях, построении семьи, бизнесе и других. Большинство из них являются результатом низкого уровня индивидуального/группового/глобального психоанализа и психологии в целом. Одной из самых больших проблем является эпидемия КПМ. Почти невозможно вырасти в современном мире без серьезных травм психики и, как следствие, диагнозов. ' +
        //         '<br/><br/>' +
        //         'Основные цели PSY-Конвенции:' +
        //         '<br/>' +
        //         '• помочь людям, не являющимся профессионалами, совершенствовать навыки, связанные с психологией' +
        //         '<br/>' +
        //         '• помочь отдельным профессионалам улучшить навыки и перестать делать ошибки' +
        //         '<br/>' +
        //         '• помочь повысить уровень психоанализа в сообществах по всему миру' +
        //         '<br/>' +
        //         '• помочь защитить права человека при лечении, используя различные методы: глобально, локально' +
        //         '<br/>' +
        //         '• бороться с эпидемией кпм и укреплять/помогать другим на местном/глобальном уровне' +
        //         '<br/>' +
        //         '• и другие, улучшая качество здравоохранения, помогая вырастить хороших специалистов и защитить права человека при лечении' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">PSY-Конвенция 2018:</font>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">PSY-Конвенция 2018. Пункт 1.</font> Разделение полномочий' +
        //         '<br/>' +
        //         'очень часто диагностика субъективна и ошибочна. что уже является преступлением и препятствует обдумыванию неверного диагноза, так же как и боязнь за личную репутацию. эти факторы, а также, часто, нулевой унровень психоанализа и собственный букет симптомов психического расстройства, делают практически невозможным исправление диагноза на добровольной инициативе сотрудника, допустившего ошибку. необходимо лишить власти медицинских работников нарушать конституционные права человека и отправлять на обязательное лечение от несуществующей или ошибочной болезни. нарушение конституционных прав может быть только по решению суда, когда идет речь о преступлениях совершенных из-за симпомов. например, попытки доведения до суицида или возбуждение вражды, если мотивом этих преступлений были симптомы душевной болезни. резюме: лишить незаконной власти медицинских работников, которая фактически используется для совершения множества преступлений из УК РФ. сделать процедуру госптализации полностью прозрачной и в обязательном порядке проверять на нарушение 293, 126, 110 статей уголовного кодекса РФ' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">PSY-Конвенция 2018. Пункт 2.</font> Начинать с психоанализа - всегда' +
        //         '<br/>' +
        //         'для разных типов личности характерны разные процессы в психике. одинаковые обстоятельства и/или воздествие могут вызвать совершенно разные и/или противоположные процессы психики в разных типах личности. не учитывать данное обстоятельство - очень грубая и популярная ошибка. чаще всего, сознательный, прогнозируемы эффект на психику без этого этапа невозможен. резюме: всегда начинать с писхоанализа не только пациента или клиента, но и максимально точного психоанализа лиц, с которыми он/она контактирует. очень часто правильно сформулированное условие - это 90+ процентов решения.' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">PSY-Конвенция 2018. Пункт 3.</font> Ясная причинно-следственная связь' +
        //         '<br/>' +
        //         'очень много субьективных теорий и точек зрения сегодня называют словом психология. большинство из них базируется на болезненном, не систематизированном опыте, который пережил автор той или иной теории. все эти теории не являются наукой, т.к. в них нет причинно-следственных связей. это вводит людей в заблуждение. наука о человеческой психике, психология имеет четкие и прозрачные причинно следственные связи. использовать можно только те методики, в которых причинно следственная связь прослеживается полностью. иначе это все, что угодно. но не наука о человеческой психики - психология. это может быть философия, мистика, мошенничество и т.п. резюме: в любом утверждении должна прследиваться причинно слдественная связь к базовым процессам в психике' +
        //         '<br/><br/>' +
        //         '<br/><br/>' +
        //         '<font class="text_bw_title">Пожалуйста, войдите в систему, чтобы увидеть другие пункты PSY Convention 2019 и поработать над ними, прежде чем конвенция 2019 будет финализирована.</font>' +
        //         '</div>';
        // }
    }

    /**
     * when user change language or go to home page
     * this function will reset selected menu item
     */
    resetTopMenuSelections() {
        // this.topMenuComponentLink.resetMenuColors();
        this.topMenuComponentLink.booksButtonMenuColor = 'white';
        this.topMenuComponentLink.booksButtonMenuColor = 'white';
        this.topMenuComponentLink.aboutButtonMenuColor = 'white';
        this.topMenuComponentLink.rightButtonMenuColor = 'white';
        this.topMenuComponentLink.leftButtonMenuColor = 'white';
        this.topMenuComponentLink.centerButtonMenuColor = 'white';
        this.topMenuComponentLink.instrumentsButtonMenuColor = 'white';
        this.topMenuComponentLink.conventionButtonMenuColor = 'white';
        this.topMenuComponentLink.eventsButtonMenuColor = 'white';
        this.topMenuComponentLink.newsButtonMenuColor = 'white';
        this.topMenuComponentLink.cmmButtonMenuColor = 'white';
        this.topMenuComponentLink.supportButtonMenuColor = 'white';
        this.topMenuComponentLink.psyButtonMenuColor = 'white';
        this.topMenuComponentLink.whoButtonMenuColor = 'white';
    }

    /**
     * Actual list of AHM communities
     */
    communityContent() {
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'community';
        this.homeComponentLink.dynamicPageDisplay = 'none';
        // choose language
        // this.resetComponents();
        // // hide login form
        // this.hideLoginForm();
        // // put back button
        // this.navigationComponentLink.backButtonDisplay = 'block';
        // this.homeComponentLink.mainPageDisplay = 'none';
        // this.dynamicComponentLink.viewContent =
        //     '<br/><br/>' +
        //     '<font size="5" style="color: black; background-color: white; cursor: pointer;">' +
        //     'AHM COMMUNITY' +
        //     '</font>' +
        //     '<br/><br/>' +
        //     'Join AHM community here' +
        //     '<br/><br/>' +
        //     'In Telegram: <a href="https://t.me/ahm_community" target="_blank">ahm_community</a> for chating every topic about or near' +
        //     ' the human psyche with causal relationship, evidence and great effect/interest.' +
        //     '<br/><br/>' +
        //     'IN: VK, FB, YT...' +
        //     '';
    }

    hideLoginForm() {
        this.homeComponentLink.loginFormDisplay = 'none';
    }

    showLoginForm() {
        this.homeComponentLink.loginFormDisplay = 'block';
    }

    setMainContentComponentLink(link) {
        // console.log('mainContentComponentLink', link);
        this.mainContentComponentLink = link;
    }

    getMainContentComponentLink() {
        return this.mainContentComponentLink;
    }

    setLeftPanelComponentLink(link) {
        this.leftPanelComponentLink = link;
    }

    setLoginFormComponentLink(link) {
        this.loginFormComponentLink = link;
    }

    setTopMenuComponentLink(link) {
        this.topMenuComponentLink = link;
    }

    setDynamicComponentLink(link) {
        this.dynamicComponentLink = link;
    }

    setAppComponentLink(link) {
        this.appComponentLink = link;
    }

    setNavigationComponentLink(link) {
        this.navigationComponentLink = link;
    }

    setHomeComponentLink(link) {
        this.homeComponentLink = link;
    }

    setLanguageSiteVersion(language) {
        this.version = language;
        // this.language = language;
        // alert(this.language);
    }

    setLoginOk(userName = '') {
        this.homeComponentLink.signedInSpan = '<b>' + userName + '</b>';
        this.homeComponentLink.signedInColor = 'green';
    }

    setHospital() {
        this.setHospitalComponentActive();
    }

    setHospitalComponentActive() {
        this.homeComponentLink.hospitalPageDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.loginFormDisplay = 'none';
        this.homeComponentLink.dynamicPageDisplay = 'none';
    }

    resetComponents() {
        this.homeComponentLink.hospitalPageDisplay = 'none';
        this.homeComponentLink.mainPageDisplay = 'block';
        // this.homeComponentLink.loginFormDisplay = 'none';
        this.homeComponentLink.dynamicPageDisplay = 'block';
        this.dynamicComponentLink.sliderHidden = true;
        this.homeComponentLink.selectedPage = '';
    }

    makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    whoelseContent() {
        this.resetComponents();
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'whoelse';
        this.homeComponentLink.dynamicPageDisplay = 'none';
    }

    helperContentBlock() {
        this.resetComponents();
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'helper';
        this.homeComponentLink.dynamicPageDisplay = 'none';
    }

    appsContentBlock() {
        this.resetComponents();
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'apps';
        this.homeComponentLink.dynamicPageDisplay = 'none';
    }

    appsPartnersBlock() {
        this.resetComponents();
        this.resetComponents();
        // hide login form
        this.hideLoginForm();
        // put back button
        this.navigationComponentLink.backButtonDisplay = 'block';
        this.homeComponentLink.mainPageDisplay = 'none';
        this.homeComponentLink.selectedPage = 'partners';
        this.homeComponentLink.dynamicPageDisplay = 'none';
    }
}
